import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'
import './PRSStatusBadge.scss'

const PRSStatusBadge = ({
  variant = "",
  tooltipType = 'study',
  tooltipPlacement,
  diagnolStyle, // override diagnoal line style
  style = {},
}) => {
  const title = React.useMemo(() => {
    switch (variant) {
      case "new":
        return 'New'
      case "no-ctg":
        return 'CTG'
      case "no-source":
        return 'Source'
      case "recruitment":
        return 'Recruitment Status'
      default:
        return ''
    }
  }, [variant])

  const tooltipText = React.useMemo(() => {
    switch (variant) {
      case "new":
        return tooltipType === 'site' ? 'This site was imported from a source in the latest upload and was not present in the previous upload or was manually created.' : 'This study was imported from a source in the latest upload and was not present in the previous upload.'
      case "no-ctg":
        return tooltipType === 'site' ? 'This site does not exist in PRS, but will be added if the study is uploaded to PRS.' : 'This study does not exist in CTG and will not be able to be uploaded.'
      case "no-source":
        return tooltipType === 'site' ? 'This site will be deleted on PRS if the study is uploaded, since it is not present in Site Management.' : 'This study was not imported from a source and cannot be submitted to PRS. Please review the source data.'
      case "recruitment": // site only
        return 'This site recruitment status is different from the previously stored value due to data import or manual update by a user.'
      default:
        return ''
    }
  }, [variant, tooltipType])

  return <Tooltip title={tooltipText} placement={tooltipPlacement}>
    <div className={`site-status-badge ${variant}`}
      variant={variant} style={style}>
      {variant === "recruitment" &&
        <i className="far fa-triangle" />
      }
      {(variant === "no-ctg" || variant === "no-source") &&
        <div
          className={`diaganol-line ${variant}`}
          variant={variant}
          style={diagnolStyle} />
      }
      <span>{title}</span>
    </div>
  </Tooltip>
}

PRSStatusBadge.propTypes = {
  variant: PropTypes.oneOf(["new", "no-ctg", "no-source", "recruitment"]),
  tooltipType: PropTypes.oneOf(["study", "site"]),
  diagnolStyle: PropTypes.object,
  style: PropTypes.object,
}

export default PRSStatusBadge